class NewCatalogApi {
  constructor (ctx) {
    this.ctx = ctx
  }

  getNomenclatureGroups = async (params) => {
    const res = await this.ctx.get('/new_catalog/nomenclature_groups/', params)

    return res.data
  }

  getNomenclatureGroupSlug = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/`)

    return res.data
  }

  getNomenclatureGroupForSidebar = async () => {
    const res = await this.ctx.get('/new_catalog/nomenclature_groups/for_sidebar/')

    return res.data
  }

  getNomenclatureGroupHowChoice = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/how_choice/`)

    return res.data
  }

  getProductBySlug = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/products/${slug}/`)

    return res.data
  }

  getRelatedProductsBySlug = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/products/${slug}/related/`)

    return res.data
  }

  getNgProductsBySlug = async ({slug, ...params}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/products/`, params)

    return res.data
  }

  getNgSubgroupsBySlug = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/subgroups/`)

    return res.data
  }

  getRecommendedProducts = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/products/recomended/`)

    return res.data
  }

  getRelatedCategoriesBySlug = async ({slug}) => {
    const res = await this.ctx.get(`/new_catalog/nomenclature_groups/${slug}/related_categories/`)

    return res.data
  }

  getPopularProducts = async () => {
    const res = await this.ctx.get('/new_catalog/products/popular/')

    return res.data
  }

  getBreadcrumbs = async ({ type, slug }) => {
    const res = await this.ctx.get('/new_catalog/breadcrumbs/', { type, slug })

    return res.data
  }
}

export default NewCatalogApi
